module.exports = __webpack_public_path__ + "static/media/LetsGo.442974d7.mp3";